import { Injectable } from '@angular/core';
import { BenchmarkProfile } from '../core-data-model/BenchmarkProfile.model';
import { BenchmarkProfilesResponseServer } from '../core-data-model/BenchmarkProfileApi.serverinterface';
import { BenchmarkProfileTransformers } from '../core-services/BenchmarkProfileApi.datatransform';
import { ApiService } from '../system-services/Api.service';

@Injectable({
    providedIn: 'root'
})
export class BenchmarkProfileApi {
    constructor(
        private api: ApiService,
        private transformer: BenchmarkProfileTransformers
    ) {}

    /* This is going to be written against the existing API for testing, button
    we will be writing a server pass through since we want this to be controlled
    via an access key */

    getPossibleProfiles(onetSocCode: string): Promise<BenchmarkProfile[]> {
        // call the API for the top profile in English. If need to be in other language, specify languageLocale in the query.
        return this.api
            .get<BenchmarkProfilesResponseServer>(
                `/api/v3/jobs/benchmarkProfile?onetSocCode=${onetSocCode}&top=1`
            )
            .then(([response]) => {
                if (response.benchmarkProfiles.length) {
                    return response.benchmarkProfiles.map((entry) =>
                        this.transformer.transformFromServer(entry)
                    );
                } else {
                    return [];
                }
            });
    }
}
